// Import the functions you need from the SDKs you need
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAl3b1GJz48-yj5oYITRF39fdx0IF0P6Ao",
  authDomain: "crypto-tracker-e9543.firebaseapp.com",
  projectId: "crypto-tracker-e9543",
  storageBucket: "crypto-tracker-e9543.appspot.com",
  messagingSenderId: "936886059898",
  appId: "1:936886059898:web:21424d9d5348de980a8cc3",
  measurementId: "G-XR8M7TYL0P"
};

// Initialize Firebase


export default firebaseConfig ;